import styled from '@emotion/styled';
import Colors from '../theme/colors';
import { Text4 } from './Text4';

export const Text5 = styled(Text4)`
  color: ${Colors.text_1};
  font-weight: 900;
`;
